import React, { useState } from "react";

import { checkOrganizationNameTakenAPI } from "utils/organization/api";

import Input from "components/Input";
import Button from "components/Button";

import classes from "../style.module.scss";

const MIN_NAME_LENGTH = 4;

const NameStep = ({ name, setName, onCancel, onContinue }) => {
    const [error, setError] = useState("");
    const [checking, setChecking] = useState(false);

    const trimmedName = name.trim();
    const isLongEnough = trimmedName.length >= MIN_NAME_LENGTH;
    const message = error || (trimmedName && !isLongEnough ? "Use more than 3 characters." : "");

    const handleChange = (value) => {
        setName(value);
        setError("");
    };

    const handleContinue = async () => {
        setChecking(true);
        setError("");

        // DashboardAPI returns the error instead of throwing, so check the status
        const { data: { taken = false } = {}, status = 0 } = await checkOrganizationNameTakenAPI({
            name: trimmedName,
        });

        setChecking(false);

        if (status !== 200) {
            setError("Could not check that name. Please try again.");
            return;
        }

        if (taken) {
            setError("That name is already taken. Try another one.");
            return;
        }

        onContinue();
    };

    return (
        <>
            <p>Please provide a name for your organization.</p>
            <Input
                label="Organization Name"
                placeholder="Your Company"
                meta={{ invalid: Boolean(message), error: message }}
                setTouched
                input={{ value: name, onChange: handleChange }}
            />
            <div className={classes.footer}>
                <Button onClick={onCancel} type="red">
                    Cancel
                </Button>
                <Button onClick={handleContinue} disabled={!isLongEnough || checking}>
                    {checking ? "Checking..." : "Continue"}
                </Button>
            </div>
        </>
    );
};

export default NameStep;
